/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `info` - Informative
 * * `low` - Low
 * * `medium` - Medium
 * * `high` - High
 * * `critical` - Critical
 * @export
 */
export const DataLeakSeverityEnum = {
    Info: 'info',
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Critical: 'critical'
} as const;
export type DataLeakSeverityEnum = typeof DataLeakSeverityEnum[keyof typeof DataLeakSeverityEnum];


export function instanceOfDataLeakSeverityEnum(value: any): boolean {
    for (const key in DataLeakSeverityEnum) {
        if (Object.prototype.hasOwnProperty.call(DataLeakSeverityEnum, key)) {
            if (DataLeakSeverityEnum[key as keyof typeof DataLeakSeverityEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataLeakSeverityEnumFromJSON(json: any): DataLeakSeverityEnum {
    return DataLeakSeverityEnumFromJSONTyped(json, false);
}

export function DataLeakSeverityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataLeakSeverityEnum {
    return json as DataLeakSeverityEnum;
}

export function DataLeakSeverityEnumToJSON(value?: DataLeakSeverityEnum | null): any {
    return value as any;
}

export function DataLeakSeverityEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DataLeakSeverityEnum {
    return value as DataLeakSeverityEnum;
}

